export default "__VITE_ASSET__BWCYyJ7W__"